import type { CSSProperties } from "react";
import {
  CRC_CARD_BACKGROUND_COLOR,
  CRC_DIVIDER,
  CRC_PLATE_BACKGROUND_COLOR,
  CRC_R_CARD,
} from "@/components/ui/Cresultcard/cresultcard.tokens";

/**
 * The surface a persisted attach block is drawn ON, wherever it is drawn.
 *
 * One material, one home. Every attach card sits in the same slot of a version
 * body, so they wear the same plate — the kit's plate fill, the card radius
 * plus its own 4px inset — and a card that invented its own container would
 * make two blocks in one document look like two different products.
 */
export const CATTACHEDRESULT_PLATE_STYLE: CSSProperties = {
  display: "grid",
  gap: 10,
  minWidth: 0,
  padding: 4,
  borderRadius: CRC_R_CARD + 4,
  backgroundColor: CRC_PLATE_BACKGROUND_COLOR,
};

/** One item's own tile inside that plate — the lossless render's row material,
 *  shared so a dedicated card that needs a plain tile draws the same one. */
export const CATTACHEDRESULT_TILE_STYLE: CSSProperties = {
  minWidth: 0,
  padding: 13,
  border: `1px solid ${CRC_DIVIDER}`,
  borderRadius: CRC_R_CARD,
  backgroundColor: CRC_CARD_BACKGROUND_COLOR,
};
